import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import facebook from "@baseImg/footer/Social/icon-facebook.svg";
import instagram from "@baseImg/footer/Social/icon-instagram.svg";
import linkedin from "@baseImg/footer/Social/icon-linkedin.svg";
import tiktok from "@baseImg/footer/Social/icon-tiktok.svg";
import youtube from "@baseImg/footer/Social/icon-youtube.svg";

const BG = {
	title: 'Социални мрежи:',
	content: [
		{
			link: '<a href="https://www.facebook.com/superhosting" title="Facebook" target="_blank">Facebook</a>',
			icon: facebook,
			iconAlt: 'Facebook'
		},
		{
			link: '<a href="https://www.instagram.com/superhosting.bg" title="Instagram" target="_blank">Instagram</a>',
			icon: instagram,
			iconAlt: 'Instagram'
		},
		{
			link: '<a href="https://www.linkedin.com/company/superhosting-bg/" title="LinkedIn" target="_blank">LinkedIn</a>',
			icon: linkedin,
			iconAlt: 'LinkedIn'
		},
		{
			link: '<a href="https://www.tiktok.com/@superhostingbg" title="TikTok" target="_blank">TikTok</a>',
			icon: tiktok,
			iconAlt: 'Tiktok'
		},
		{
			link: '<a href="https://www.youtube.com/user/SuperHostingBg" title="YouTube" target="_blank">YouTube</a>',
			icon: youtube,
			iconAlt: 'YouTube'
		}
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	title: 'Social networks:',
	content: [
		{
			link: '<a href="https://www.facebook.com/superhosting" title="Facebook" target="_blank">Facebook</a>',
			icon: facebook,
			iconAlt: 'Facebook'
		},
		{
			link: '<a href="https://www.instagram.com/superhosting.bg" title="Instagram" target="_blank">Instagram</a>',
			icon: instagram,
			iconAlt: 'Instagram'
		},
		{
			link: '<a href="https://www.linkedin.com/company/superhosting-bg/" title="LinkedIn" target="_blank">LinkedIn</a>',
			icon: linkedin,
			iconAlt: 'LinkedIn'
		},
		{
			link: '<a href="https://www.tiktok.com/@superhostingbg" title="TikTok" target="_blank">TikTok</a>',
			icon: tiktok,
			iconAlt: 'Tiktok'
		},
		{
			link: '<a href="https://www.youtube.com/user/SuperHostingBg" title="YouTube" target="_blank">YouTube</a>',
			icon: youtube,
			iconAlt: 'YouTube'
		}
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];